var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowTriangleDown = function SvgArrowTriangleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.682 12.674c.01-.012.014-.028.024-.04l6.982-7.714c.39-.434.39-1.138 0-1.572q-.006-.005-.012-.008a.94.94 0 0 0-.712-.34H.998a.95.95 0 0 0-.722.352l-.004-.004c-.39.451-.39 1.12 0 1.572l6.998 7.754a.928.928 0 0 0 1.412 0"
  })));
};
export default SvgArrowTriangleDown;